import { render, staticRenderFns } from "./displayServicesCustomers.vue?vue&type=template&id=41daedb6&scoped=true&"
import script from "./displayServicesCustomers.vue?vue&type=script&lang=js&"
export * from "./displayServicesCustomers.vue?vue&type=script&lang=js&"
import style0 from "./displayServicesCustomers.vue?vue&type=style&index=0&id=41daedb6&scoped=true&lang=css&"
import style1 from "./displayServicesCustomers.vue?vue&type=style&index=1&id=41daedb6&scoped=true&lang=css&"
import style2 from "./displayServicesCustomers.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41daedb6",
  null
  
)

export default component.exports